<template>
  <div>
    <div class="el-tabs el-tabs--top el-tabs--border-card card">
      <div class="el-tabs__header is-top">
        <div class="el-tabs__nav-wrap is-top">
          <div class="el-tabs__nav-scroll">
            <div role="tablist" class="el-tabs__nav is-top is-stretch" style="transform: translateX(0px);">
              <router-link
                to="/stats/revenue"
                class="el-tabs__item is-top"
                tag="div"
                active-class="is-active"
              >
                Umsatz
              </router-link>
              <router-link
                to="/stats/warehouses"
                class="el-tabs__item is-top"
                tag="div"
                active-class="is-active"
              >
                Lagerwert
              </router-link>
              <router-link
                to="/stats/unused"
                class="el-tabs__item is-top"
                tag="div"
                active-class="is-active"
              >
                Lagerhüter
              </router-link>
              <router-link
                to="/stats/rotations"
                class="el-tabs__item is-top"
                tag="div"
                active-class="is-active"
              >
                Einbuchungen / Ausbuchungen
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="el-tabs__content">
        <div role="tabpanel" id="pane-Route" aria-labelledby="tab-Route" class="el-tab-pane">
          <transition name="el-fade-in-linear">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'

export default {
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  data () {
    return {
      tab: 'Config'
    }
  },
  methods: {
  },
  computed: {
  },
  created () {
  }
}
</script>
